export default __webpack_public_path__ + "static/media/marker-blue-red-yellow.f1d3bf6f.png";